import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'JobIconPipe'})

export class JobIconPipe implements PipeTransform  {

    private unknownType = 'car';
    private jobIcons = {O : 'home', S: 'laptop', R: 'phone' };

    constructor(){}

    transform(value) {
        return (this.jobIcons[value]) ? this.jobIcons[value] : this.unknownType;

    }
}
